import { Injectable } from '@angular/core';
import { CrmEndpointDecorator } from '@touch4it/ng-swp/endpoint';

import { Endpoint } from '~/shared/endpoint/endpoint';

import { CurrencyModel } from './currency.model';

@Injectable({ providedIn: 'root' })
export class CurrenciesApiService {
  @CrmEndpointDecorator({
    endpointName: 'currencies',
    configName: 'api',
    endpoint: Endpoint,
  })
  private endpoint!: Endpoint<CurrencyModel>;

  listAll() {
    return this.endpoint.request<CurrencyModel[]>('GET', 'all');
  }
}
